import { BrowserRouter as Router } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "./stores";
import { logout } from "./features/auth-module/authSlice";
import AppRoutes from './AppRoutes';

function App() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    // Listen for token expiration event from API interceptor
    const handleTokenExpired = () => {
      dispatch(logout());
    };

    window.addEventListener("auth:tokenExpired", handleTokenExpired);

    return () => {
      window.removeEventListener("auth:tokenExpired", handleTokenExpired);
    };
  }, [dispatch]);

  return (
    <Router>
      <AppRoutes  />
    </Router>
  );
}

export default App;
